module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/schedule_02-40279140e4c6f51d5068c6babf9d9dae.jpg";